'use client';

import { useRouter } from 'next/navigation';

import { PostSummary } from '@/lib/mdx';

import NavBlog from './NavBlog';
import type { User } from 'next-auth';

interface NavBlogWrapperProps {
  posts: PostSummary[];
  user: User | null;
}

export default function NavBlogWrapper({
  user
}: Omit<NavBlogWrapperProps, 'posts'>) {
  const router = useRouter();

  const handleSignOut = async () => {
    try {
      const { signOut } = await import('next-auth/react');
      await signOut({ redirect: false });
      
      const host = window.location.hostname;
      // If we're on a blog subdomain (e.g., blog.bioinfometrics.com), 
      // we want to redirect to the main landing page (bioinfometrics.com).
      if (host.startsWith('blog.')) {
        const mainDomain = host.replace('blog.', '');
        const protocol = window.location.protocol;
        window.location.href = `${protocol}//${mainDomain}/`;
      } else {
        // If already on main domain or blog path, just go to root
        window.location.href = '/';
      }
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <NavBlog
      user={user}
      onSignOut={handleSignOut}
    />
  );
}
